/**
 * maptag.jsx
 *
 * @Author: zhangce
 * @Date: 17/8/23 上午11:36
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Close from '../icons/internals/Close';

/**
 * MapTag
 * */
class MapTag extends React.PureComponent {
  static propTypes = {
    /**
     * 类前缀
     * */
    prefixCls: PropTypes.string,
    /**
     * 类名
     * */
    className: PropTypes.string,
    /**
     * 标签类型
     * */
    color: PropTypes.string,
    /**
     * 是否禁用
     * */
    disabled: PropTypes.bool,
    /**
     * 是否可关闭标签
     * */
    closable: PropTypes.bool,
    /**
     * 标签是否为创建标签
     * */
    input: PropTypes.bool,
    /**
     * 删除动画结束
     * */
    afterClose: PropTypes.func,
    /**
     * 点击删除标签回调
     * */
    onClose: PropTypes.func,
    /**
     * 点击标签回调
     * */
    onClick: PropTypes.func,
    /**
     * 添加标签回调
     * */
    onCreate: PropTypes.func,
    /**
     * 创建新标签的键值
     * */
    enterKey: PropTypes.array,
    /**
     * 提示信息
     * */
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    transitionDuration: PropTypes.number,
  };

  static defaultProps = {
    prefixCls: 'ne-maptag',
    closable: false,
    size: 'medium',
    enterKey: [13],
    transitionDuration: 200,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      isClosed: false,
      showInput: false,
      inputValue: '',
      closing: false,
    };
  }

  componentDidUpdate() {
    const { showInput } = this.state;
    if (showInput) {
      this.createInput && this.createInput.focus();
    }
  }

  componentWillMount() {
    this.unMount = true;
  }

  onDelete = (e, uuid) => {
    const { onDelete, disabled, transitionDuration, afterClose, onClose } = this.props;
    const handleClose = onDelete || onClose;
    if (handleClose && !disabled) {
      handleClose(uuid);
    }
    if (e.defaultPrevented || disabled) {
      return;
    }
    this.setState({
      closing: true,
    });
    setTimeout(() => {
      if (this.unMount) {
        this.setState({
          isClosed: true,
        });
      }
      if (afterClose) {
        afterClose();
      }
    }, transitionDuration);
  };

  showInput = e => {
    const { onClick } = this.props;
    if (onClick) {
      onClick(e);
    }
    this.setState(state => ({
      showInput: !state.showInput,
    }));
  };

  onInputBlur = () => {
    const { onCreate, onInput } = this.props;
    const { inputValue } = this.state;
    let showInput = false;
    if (inputValue === '') {
      showInput = false;
    } else if (onCreate) {
      showInput = !onCreate(inputValue);
    } else if (onInput) {
      showInput = !onInput(inputValue);
    }
    if (!showInput) {
      this.setState({
        showInput,
        inputValue: '',
      });
    }
  };

  handleChange = e => {
    this.setState({
      inputValue: e.target.value,
    });
  };

  onKeyDown = e => {
    const { enterKey } = this.props;
    const charCode = e.which ? e.which : e.keyCode;
    if (enterKey.indexOf(charCode) !== -1) {
      e.preventDefault();
      this.onInputBlur();
    }
  };

  getInputElement = el => {
    this.createInput = el;
  };

  render() {
    const { isClosed, showInput, inputValue, closing } = this.state;
    const {
      prefixCls,
      children,
      closable,
      isAddableMapTag,
      input,
      className,
      onClick,
      onInput,
      onCreate,
      onDelete,
      type,
      disabled,
      afterClose,
      enterKey,
      title,
      color,
      size,
      uuid,
      transitionDuration,
      ...other
    } = this.props;
    const closeBtn =
      closable && !isAddableMapTag && !input ? (
        <Close className={`${prefixCls}-icon-close`} size="small" onClick={(e) => {this.onDelete(e, uuid)}} />
      ) : null;
    const classString = classNames(
      prefixCls,
      {
        [`${prefixCls}-${color}`]: color,
        [`${prefixCls}-disabled`]: disabled,
        [`${prefixCls}-create`]: isAddableMapTag || input,
        [`${prefixCls}-create-active`]: (isAddableMapTag || input) && showInput,
        [`${prefixCls}-closing`]: closing,
      },
      `${prefixCls}-${size}`,
      className,
    );
    const maptag = isClosed ? null : (
      <div
        className={classString}
        onClick={isAddableMapTag || input ? this.showInput : onClick}
        {...other}>
        {(isAddableMapTag || input) && showInput ? (
          <input
            disabled={disabled}
            className={`${prefixCls}-input`}
            ref={this.getInputElement}
            value={inputValue}
            onChange={this.handleChange}
            onKeyDown={this.onKeyDown}
            onBlur={this.onInputBlur}/>
        ) : (
          <span className={`${prefixCls}-content`} title={title}>
            {children}
          </span>
        )}
        {closeBtn}
      </div>
    );

    return maptag;
  }
}

export default MapTag;



// WEBPACK FOOTER //
// ./src/maptag/MapTag.jsx